export const guestRoutes = [
    {
        path: "/",
        name: "Home",
        component: () => import(/* webpackChunkName: "home" */ "@views/guests/home/HomePage.vue")
    },
    {
        path: "/login",
        name: "Log in",
        component: () => import(/* webpackChunkName: "login" */ "@views/guests/login/LoginPage.vue")
    },
    {
        path: "/about-us",
        name: "About Us",
        component: () => import(/* webpackChunkName: "about-us" */ "@views/guests/about-us/AboutUsPage.vue")
    },
    {
        path: "/partners",
        name: "Partners",
        component: () => import(/* webpackChunkName: "partners" */ "@views/guests/partners/PartnersPage.vue")
    },
    {
        path: "/partners/form",
        name: "Partner Application",
        component: () => import(/* webpackChunkName: "partners" */ "@views/guests/partners/registration/PartnerRegistrationPage.vue")
    },
    {
        path: "/how-it-works",
        name: "How It Works",
        component: () => import(/* webpackChunkName: "how-it-works" */ "@views/guests/how-it-works/HowItWorksPage.vue")
    },
    {
        path: "/faqs",
        name: "FAQS",
        component: () => import(/* webpackChunkName: "faqs" */ "@views/guests/faqs/FaqsPage.vue")
    },
    {
        path: "/contact-us",
        name: "Contact Us",
        component: () => import(/* webpackChunkName: "contact-us" */ "@views/guests/contact-us/ContactUsPage.vue")
    },
    {
        path: "/sign-up",
        name: "Sign up",
        component: () => import(/* webpackChunkName: "sign-up" */ "@views/guests/sign-up/SignUpPage.vue")
    },
    {
        path: "/policy-statement",
        name: "Policy Statement",
        component: () => import(/* webpackChunkName: "terms-and-conditions" */ "@views/guests/terms-and-conditions/policy-statement/PocilyStatementPage.vue")
    },
    {
        path: "/privacy-policy",
        name: "Privacy Policy",
        component: () => import(/* webpackChunkName: "terms-and-conditions" */ "@views/guests/terms-and-conditions/privacy-policy/PrivacyPolicyPage.vue")
    },
    {
        path: "/supply-of-services",
        name: "Supply of Services",
        component: () => import(/* webpackChunkName: "terms-and-conditions" */ "@views/guests/terms-and-conditions/supply-of-services/SupplyOfServicesPage.vue")
    },
    {
        path: "/book-now",
        name: "Book Now Page",
        component: () => import(/* webpackChunkName: "booking" */ "@views/bookings/create/BookingCreatePage.vue"),
    },

    {
        path: "/shops/:id",
        name: "Shop Page",
        component: () => import(/* webpackChunkName: "shop" */ "@views/shops/ShopsPage.vue"),
        
        children: [
            {
                path: "about",
                name: "About",
                component: () => import(/* webpackChunkName: "shop" */ "@views/shops/about/AboutPage.vue")
            },
            {
                path: "services",
                name: "Services & Packages",
                component: () => import(/* webpackChunkName: "shop" */ "@views/shops/services/ServicesPage.vue")
            },
            {
                path: "schedueles",
                name: "Business Hours",
                component: () => import(/* webpackChunkName: "shop" */ "@views/shops/schedules/SchedulePage.vue")
            },
            {
                path: "experts",
                name: "Experts",
                component: () => import(/* webpackChunkName: "shop" */ "@views/shops/experts/ExpertsPage.vue")
            },
            {
                path: "vouchers",
                name: "Vouchers",
                component: () => import(/* webpackChunkName: "shop" */ "@views/shops/vouchers/VouchersPage.vue")
            },
        ],
    },
];

export const authenticatedRoutes = [
    {
        path: "/logout",
        name: "Logout",
        component: () => import(/* webpackChunkName: "customer-auth" */ "@views/auth/LogoutPage.vue")
    },
    {
        path: "/announcements/:id",
        name: "Announcement Page",
        component: () => import(/* webpackChunkName: "customer-auth" */ "@views/announcements/AnnouncementPage.vue")
    },

    {
        path: "/user",
        name: "Customer Page",
        component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/CustomerPage.vue"),
        children: [
            {
                path: "profile",
                name: "My Profile",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/profile/ProfilePage.vue")
            },
            {
                path: "bookings",
                name: "Bookings",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/bookings/BookingListPage.vue")
            },
            {
                path: "penalties",
                name: "Bookings Penalties",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/penalties/PenaltiesListPage.vue")
            },
            {
                path: "addresses",
                name: "Booking Addresses",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/addresses/BookingAddressesListPage.vue")
            },
            {
                path: "favorite-shops",
                name: "Favorite Shops",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/favorite-shops/FavoriteShopListPage.vue")
            },
            {
                path: "vouchers",
                name: "My Vouchers",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/vouchers/VocuherListPage.vue")
            },
            {
                path: "points",
                name: "Points History",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/points/PointListPage.vue")
            },
            {
                path: "notifications",
                name: "Notifications",
                component: () => import(/* webpackChunkName: "customer" */ "@views/users/customers/notifications/NotificationListPage.vue")
            },
        ]
    },

    {
        path: "/bookings/create",
        name: "Create Booking Page",
        component: () => import(/* webpackChunkName: "booking" */ "@views/bookings/create/BookingCreatePage.vue"),
    },

    {
        path: "/bookings/create/:id",
        name: "Create Booking via Shop Page",
        component: () => import(/* webpackChunkName: "booking" */ "@views/bookings/create-via-shop/BookingCreateViaShopPage.vue"),
    },

    {
        path: "/bookings/:id",
        name: "Booking Page",
        component: () => import(/* webpackChunkName: "booking" */ "@views/bookings/BookingsPage.vue"),
    },

    // {
    //     path: "/shops/:id",
    //     name: "Shop Page",
    //     component: () => import(/* webpackChunkName: "shop" */ "@views/shops/ShopsPage.vue"),
        
    //     children: [
    //         {
    //             path: "about",
    //             name: "About",
    //             component: () => import(/* webpackChunkName: "shop" */ "@views/shops/about/AboutPage.vue")
    //         },
    //         {
    //             path: "services",
    //             name: "Services & Packages",
    //             component: () => import(/* webpackChunkName: "shop" */ "@views/shops/services/ServicesPage.vue")
    //         },
    //         {
    //             path: "schedueles",
    //             name: "Business Hours",
    //             component: () => import(/* webpackChunkName: "shop" */ "@views/shops/schedules/SchedulePage.vue")
    //         },
    //         {
    //             path: "experts",
    //             name: "Experts",
    //             component: () => import(/* webpackChunkName: "shop" */ "@views/shops/experts/ExpertsPage.vue")
    //         },
    //         {
    //             path: "vouchers",
    //             name: "Vouchers",
    //             component: () => import(/* webpackChunkName: "shop" */ "@views/shops/vouchers/VouchersPage.vue")
    //         },
    //     ],
    // },

];


export default guestRoutes.concat(authenticatedRoutes)